/* EcoPalm Essentials — theme interactions
   Vanilla JS. Uses Shopify AJAX Cart API + Section Rendering API. */
(function () {
  "use strict";
  var q = function (s, r) { return (r || document).querySelector(s); };
  var qa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Header scroll shadow ---------- */
  var header = q("[data-header]");
  if (header) {
    var onScroll = function () { header.classList.toggle("is-scrolled", window.scrollY > 12); };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---------- Mobile menu ---------- */
  var menu = q("[data-mobile-menu]");
  qa("[data-menu-open]").forEach(function (b) { b.addEventListener("click", function () { menu && menu.classList.add("is-open"); document.body.style.overflow = "hidden"; }); });
  qa("[data-menu-close]").forEach(function (b) { b.addEventListener("click", function () { menu && menu.classList.remove("is-open"); document.body.style.overflow = ""; }); });

  /* ---------- Reveal on scroll ---------- */
  var reveals = qa(".reveal");
  if ("IntersectionObserver" in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-visible"); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add("is-visible"); });
  }

  /* ---------- PDP gallery, variant pills, sticky buy bar ---------- */
  (function () {
    var main = q("#pdp-main-image");
    qa(".pdp__thumb").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        if (main) main.src = thumb.getAttribute("data-thumb");
        qa(".pdp__thumb").forEach(function (x) { x.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      });
    });

    /* Variant pills write into the hidden id input the product form posts. */
    var picker = q("[data-variant-picker]");
    if (picker) {
      var idInput = q("[data-variant-id-input]");
      picker.addEventListener("click", function (e) {
        var opt = e.target.closest(".pdp__opt");
        if (!opt || opt.disabled) return;
        qa(".pdp__opt", picker).forEach(function (x) { x.classList.remove("is-active"); });
        opt.classList.add("is-active");
        if (idInput) idInput.value = opt.getAttribute("data-variant-id");

        var price = opt.getAttribute("data-price") || "";
        var cmp = opt.getAttribute("data-compare") || "";
        qa("[data-pdp-price]").forEach(function (el) { el.textContent = price; });
        var cmpEl = q("[data-pdp-compare]");
        if (cmpEl) { cmpEl.textContent = cmp; cmpEl.hidden = cmp === ""; }
        var save = q("[data-pdp-save]");
        if (save) save.hidden = cmp === "";

        /* SKU follows the selected pack size (e.g. ECP-PSY-100 → a combo pack's own SKU). */
        var sku = opt.getAttribute("data-sku") || "";
        var skuEl = q("[data-pdp-sku]");
        var skuRow = q("[data-pdp-sku-row]");
        if (skuEl) skuEl.textContent = sku;
        if (skuRow) skuRow.hidden = sku === "";

        /* Keep the address bar in step so a shared link opens this variant. */
        if (window.history && history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set("variant", opt.getAttribute("data-variant-id"));
          history.replaceState({}, "", u);
        }
      });
    }

    /* Reveal the sticky bar once the main Add to cart has scrolled away. */
    var bar = q("[data-pdp-bar]");
    var addBtn = q(".pdp__add");
    if (bar && addBtn && "IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        bar.hidden = entries[0].isIntersecting;
      }, { rootMargin: "0px 0px -80px 0px" }).observe(addBtn);
    }
  })();

  /* ---------- Product card variant selector ----------
     Each <option> carries its own pre-formatted money strings from Liquid,
     so switching variants never needs client-side currency formatting. */
  document.addEventListener("change", function (e) {
    var sel = e.target;
    if (!sel.matches || !sel.matches("[data-variant-select]")) return;
    var card = sel.closest("[data-product-card]");
    if (!card) return;
    var opt = sel.options[sel.selectedIndex];
    /* NB: the display hooks are data-card-price / data-card-compare, NOT
       data-price / data-compare — those live on the <option>s inside this
       same card, and would match first. */
    var priceEl = q("[data-card-price]", card);
    var cmpEl = q("[data-card-compare]", card);
    if (priceEl) priceEl.textContent = opt.getAttribute("data-price") || "";
    if (cmpEl) {
      var cmp = opt.getAttribute("data-compare") || "";
      cmpEl.textContent = cmp;
      cmpEl.hidden = cmp === "";
    }
  });

  /* ---------- Snap carousels (shoppable videos, testimonials) ---------- */
  qa("[data-carousel]").forEach(function (root) {
    var track = q("[data-carousel-track]", root);
    if (!track) return;
    var prev = q("[data-carousel-prev]", root);
    var next = q("[data-carousel-next]", root);

    /* Scroll by one card, so the snap points always line up. */
    function step() {
      var card = track.firstElementChild;
      if (!card) return Math.round(track.clientWidth * 0.8);
      var gap = parseFloat(getComputedStyle(track).columnGap || "16") || 16;
      return Math.round(card.getBoundingClientRect().width + gap);
    }
    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }
    /* No `behavior` here on purpose — the track's CSS `scroll-behavior`
       owns it, so the prefers-reduced-motion override actually applies.
       sync() is also called on a timer because with smooth scrolling the
       scroll event lands after the animation, and we don't want the arrow
       state to depend on that timing. */
    function nudge(dir) {
      track.scrollBy({ left: dir * step() });
      setTimeout(sync, 400);
    }
    if (prev) prev.addEventListener("click", function () { nudge(-1); });
    if (next) next.addEventListener("click", function () { nudge(1); });
    track.addEventListener("scroll", sync, { passive: true });
    window.addEventListener("resize", sync);
    sync();
  });

  /* Play carousel videos only while they are on screen — these are muted,
     looping, preload="none" clips, so nothing downloads until it is needed. */
  var vshopVideos = qa(".vshop__video");
  if ("IntersectionObserver" in window && vshopVideos.length) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          var played = v.play();
          if (played && played.catch) played.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.35 });
    vshopVideos.forEach(function (v) {
      v.muted = true;
      v.setAttribute("playsinline", "");
      vio.observe(v);
    });
  }

  /* ---------- Cart drawer open/close ---------- */
  var drawer = q("[data-cart-drawer]");
  function openDrawer() { if (drawer) { drawer.classList.add("is-open"); document.body.style.overflow = "hidden"; } }
  function closeDrawer() { if (drawer) { drawer.classList.remove("is-open"); document.body.style.overflow = ""; } }
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-cart-open]")) { e.preventDefault(); openDrawer(); }
    if (e.target.closest("[data-cart-close]")) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });

  /* ---------- Update all cart-count badges ---------- */
  function updateCounts(count) {
    qa("[data-cart-count]").forEach(function (el) {
      el.textContent = count > 99 ? "99+" : count;
      el.hidden = count < 1;
    });
  }

  /* ---------- Re-render cart drawer from Section Rendering API ---------- */
  function renderDrawer(sectionHTML) {
    if (!sectionHTML) return;
    var doc = new DOMParser().parseFromString(sectionHTML, "text/html");
    var fresh = doc.getElementById("cart-drawer-inner");
    var current = document.getElementById("cart-drawer-inner");
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    var c = doc.querySelector("[data-cart-count]");
    if (c) updateCounts(parseInt(c.getAttribute("data-count") || "0", 10));
  }

  /* ---------- Add to cart (AJAX, progressive enhancement) ---------- */
  function bindProductForm(form) {
    if (form.dataset.bound) return;
    form.dataset.bound = "1";
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = form.querySelector("[type='submit']");
      if (btn) { btn.disabled = true; btn.classList.add("is-loading"); }
      var body = new FormData(form);
      body.append("sections", "cart-drawer");
      body.append("sections_url", window.location.pathname);
      fetch("/cart/add.js", { method: "POST", headers: { "X-Requested-With": "XMLHttpRequest", "Accept": "application/javascript" }, body: body })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) { // error (e.g., sold out)
            alert(data.description || data.message || "Could not add to cart.");
            return;
          }
          if (data.sections) renderDrawer(data.sections["cart-drawer"]);
          if (form.hasAttribute("data-buy-now")) { window.location.href = "/checkout"; return; }
          openDrawer();
        })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove("is-loading"); } });
    });
  }
  function bindProductForms(root) {
    qa("form[action$='/cart/add'], form[data-product-form]", root).forEach(bindProductForm);
  }
  bindProductForms(document);

  /* ---------- Wishlist (client-side, localStorage) ---------- */
  var WISH_KEY = "ecopalm:wishlist";
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY)) || []; } catch (e) { return []; }
  }
  function setWishlist(list) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {}
    updateWishUI();
  }
  function inWishlist(handle) { return getWishlist().indexOf(handle) !== -1; }
  function toggleWishlist(handle) {
    var list = getWishlist();
    var i = list.indexOf(handle);
    if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
    setWishlist(list);
    return i === -1; // true = now saved
  }
  function updateWishUI() {
    var count = getWishlist().length;
    qa("[data-wishlist-count]").forEach(function (el) {
      el.textContent = count > 99 ? "99+" : count;
      el.hidden = count < 1;
    });
    qa("[data-wishlist-toggle]").forEach(function (btn) {
      var on = inWishlist(btn.getAttribute("data-handle"));
      btn.classList.toggle("is-active", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
      var lbl = btn.querySelector("[data-wish-label]");
      if (lbl) lbl.textContent = on ? "Saved" : (btn.getAttribute("data-label") || "Save to Wishlist");
    });
  }
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-wishlist-toggle]");
    if (!btn) return;
    e.preventDefault();
    toggleWishlist(btn.getAttribute("data-handle"));
    if (btn.closest("[data-wishlist-grid]")) renderWishlistPage(); // remove card in-place on wishlist page
  });
  updateWishUI();

  /* ---------- Money formatting (Shopify money_format placeholders) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(/[^0-9]/g, "");
    var fmt = format || "${{amount}}";
    function num(precision, thousands, decimal) {
      thousands = thousands || ","; decimal = decimal || ".";
      var n = (cents / 100).toFixed(precision);
      var parts = n.split(".");
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      return whole + (parts[1] ? decimal + parts[1] : "");
    }
    var re = /\{\{\s*(\w+)\s*\}\}/;
    var m = fmt.match(re);
    var value;
    switch (m ? m[1] : "amount") {
      case "amount_no_decimals": value = num(0); break;
      case "amount_with_comma_separator": value = num(2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = num(0, ".", ","); break;
      case "amount_with_space_separator": value = num(2, " ", ","); break;
      default: value = num(2);
    }
    return fmt.replace(re, value);
  }

  /* ---------- Wishlist page: fetch saved products & render cards ---------- */
  var wishGrid = q("[data-wishlist-grid]");
  function renderWishlistPage() {
    if (!wishGrid) return;
    var moneyFormat = wishGrid.getAttribute("data-money-format");
    var empty = q("[data-wishlist-empty]");
    var loading = q("[data-wishlist-loading]");
    var handles = getWishlist();
    if (!handles.length) {
      wishGrid.innerHTML = "";
      if (loading) loading.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    if (loading && !wishGrid.children.length) loading.hidden = false;
    Promise.all(handles.map(function (h) {
      return fetch("/products/" + h + ".js")
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      // Drop handles that no longer resolve (deleted products), keep order.
      var valid = [];
      var cleaned = [];
      handles.forEach(function (h, i) { if (products[i]) { valid.push(products[i]); cleaned.push(h); } });
      if (cleaned.length !== handles.length) {
        try { localStorage.setItem(WISH_KEY, JSON.stringify(cleaned)); } catch (e) {}
      }
      if (loading) loading.hidden = true;
      if (!valid.length) { wishGrid.innerHTML = ""; if (empty) empty.hidden = false; updateWishUI(); return; }
      wishGrid.innerHTML = valid.map(function (p) { return wishCardHTML(p, moneyFormat); }).join("");
      bindProductForms(wishGrid);
      updateWishUI();
    });
  }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function wishCardHTML(p, moneyFormat) {
    var img = p.featured_image || (p.images && p.images[0]) || "";
    var variant = null;
    if (p.variants) { for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { variant = p.variants[i]; break; } } }
    var url = "/products/" + p.handle;
    var media = img
      ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" width="600" height="750" loading="lazy">'
      : "";
    var buy = variant
      ? '<form action="/cart/add" method="post" data-product-form>' +
          '<input type="hidden" name="id" value="' + variant.id + '">' +
          '<input type="hidden" name="quantity" value="1">' +
          '<button class="add-mini" type="submit" aria-label="Add to cart">Add</button>' +
        "</form>"
      : '<span class="chip">Sold out</span>';
    return '' +
      '<div class="product-card card-lift">' +
        '<div class="product-card__media">' +
          '<button class="wish-btn is-active" data-wishlist-toggle data-handle="' + esc(p.handle) + '" aria-label="Remove from wishlist" aria-pressed="true">' +
            '<svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 21s-7-4.6-9.5-9A5.4 5.4 0 0 1 12 6a5.4 5.4 0 0 1 9.5 6c-2.5 4.4-9.5 9-9.5 9Z"/></svg>' +
          "</button>" +
          '<a href="' + url + '" aria-label="' + esc(p.title) + '">' + media + "</a>" +
        "</div>" +
        '<div class="product-card__body">' +
          '<a href="' + url + '"><h3 class="product-card__title">' + esc(p.title) + "</h3></a>" +
          '<p class="product-card__sub">' + esc(p.type || "") + "</p>" +
          '<div class="product-card__foot">' +
            '<div class="product-card__price">' + formatMoney(p.price, moneyFormat) + "</div>" +
            buy +
          "</div>" +
        "</div>" +
      "</div>";
  }
  renderWishlistPage();

  /* ---------- Quantity steppers ---------- */
  document.addEventListener("click", function (e) {
    var stepBtn = e.target.closest("[data-qty-minus], [data-qty-plus]");
    if (!stepBtn) return;
    var wrap = stepBtn.closest("[data-qty]");
    var input = wrap && wrap.querySelector("input");
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    val = stepBtn.hasAttribute("data-qty-plus") ? Math.min(val + 1, 99) : Math.max(val - 1, wrap.hasAttribute("data-qty-cart") ? 0 : 1);
    input.value = val;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* ---------- Cart line quantity change (drawer, AJAX) ---------- */
  function changeLine(key, quantity) {
    var body = { id: key, quantity: quantity, sections: "cart-drawer", sections_url: window.location.pathname };
    return fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections) renderDrawer(data.sections["cart-drawer"]);
        // If on the cart page, reload to reflect changes there too.
        if (document.body.getAttribute("data-template") === "cart") window.location.reload();
      });
  }
  document.addEventListener("change", function (e) {
    var line = e.target.closest("[data-line-key]");
    if (line && line.hasAttribute("data-drawer-line")) {
      var input = line.querySelector("input");
      changeLine(line.getAttribute("data-line-key"), parseInt(input.value, 10) || 0);
    }
  });
  document.addEventListener("click", function (e) {
    var rm = e.target.closest("[data-line-remove]");
    if (rm) { e.preventDefault(); changeLine(rm.getAttribute("data-line-remove"), 0); }
  });

  /* ---------- Cart page: apply a discount code ----------
     Shopify only accepts codes through the /discount/CODE route, which stores
     the code against the session and redirects back. Validation happens in
     Shopify at checkout — the theme never decides whether a code is valid.
     The coupon box lives inside the cart form, so it is a plain group, not a
     <form>: the button is type="button" and Enter is caught here so it never
     submits the cart. */
  var couponBox = q("[data-coupon-form]");
  if (couponBox) {
    var couponInput = q("[data-coupon-input]", couponBox);
    var applyCoupon = function () {
      var code = couponInput && couponInput.value ? couponInput.value.trim() : "";
      if (!code) { if (couponInput) couponInput.focus(); return; }
      window.location.href =
        "/discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(window.location.pathname);
    };
    var applyBtn = q("[data-coupon-apply]", couponBox);
    if (applyBtn) applyBtn.addEventListener("click", applyCoupon);
    if (couponInput) couponInput.addEventListener("keydown", function (e) {
      if (e.key === "Enter") { e.preventDefault(); applyCoupon(); }
    });
  }

  /* ---------- Certificate viewer ----------
     Certification cards with an uploaded certificate image are links to the
     full-size file (so they work without JS); with JS they open it in a
     <dialog> instead. PDF links are left to open in a new tab. */
  qa("[data-cert-modal]").forEach(function (modal) {
    if (typeof modal.showModal !== "function") return; // very old browsers: plain links still work
    var section = modal.closest(".certs") || document;
    var img = q("[data-cert-modal-img]", modal);
    var title = q("[data-cert-modal-title]", modal);
    var link = q("[data-cert-modal-link]", modal);
    var opener = null;
    qa("[data-cert-open]", section).forEach(function (card) {
      card.addEventListener("click", function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return; // let "open in new tab" work
        e.preventDefault();
        opener = card;
        var name = card.getAttribute("data-cert-title") || "";
        if (img) { img.src = card.getAttribute("data-cert-src") || card.href; img.alt = name ? name + " certificate" : "Certificate"; }
        if (title) title.textContent = name;
        if (link) link.href = card.href;
        modal.showModal();
        document.body.style.overflow = "hidden";
      });
    });
    var close = function () { if (modal.open) modal.close(); };
    qa("[data-cert-close]", modal).forEach(function (b) { b.addEventListener("click", close); });
    /* Click on the backdrop (outside the panel) closes it too. */
    modal.addEventListener("click", function (e) { if (e.target === modal) close(); });
    modal.addEventListener("close", function () {
      document.body.style.overflow = "";
      if (opener) { opener.focus(); opener = null; }
    });
  });

  /* ---------- Cart page: auto-submit the update form on stepper change ---------- */
  var cartForm = q("[data-cart-form]");
  if (cartForm) {
    cartForm.addEventListener("change", function (e) {
      if (e.target.matches("input[name^='updates']")) cartForm.submit();
    });
  }
})();
